module.exports = __webpack_public_path__ + "img/videowall-oreal.a715af76.webp";